import React from "react";
import { motion } from "framer-motion";
import "./GalleryPreview.css";
import gallery1 from '../../Images/gallery1.jpg';
import gallery2 from '../../Images/gallery2.jpg';
import gallery3 from '../../Images/gallery3.jpg';

const GalleryPreview = () => {


  const images = [
  gallery1,
    gallery2,
     gallery3

  ];

  return (
    <motion.section
      className="gallery-section"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <h2 className="gallery-heading">Gallery Preview</h2>

      <div className="gallery-layout">
        <div className="gallery-left">
          {images.slice(0, 2).map((img, i) => (
            <motion.div
              key={i}
              className="gallery-box"
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.3 }}
            >
              <img src={img} alt={`Gallery ${i}`} style={{height:"300px"}} />
            </motion.div>
          ))}
        </div>

        <motion.div
          className="gallery-right"
          whileHover={{ scale: 1.03 }}
          transition={{ duration: 0.3 }}
        >
          <img src={images[2]} alt="Couple" style={{height:"620px"}}/>
        </motion.div>
      </div>

      <hr className="gallery-divider" />
    </motion.section>
  );
};

export default GalleryPreview;

